import { FC } from 'react'
import { ReactComponent as GoogleAdsIcon } from 'src/assets/svg/google-ads.svg'
import { ReactComponent as MetaAdsIcon } from 'src/assets/svg/meta-ads.svg'
import classes from './platformToggle.module.scss'

export type AdPlatform = 'google' | 'meta'

interface PlatformToggleProps {
  onChange: (platform: AdPlatform) => void
  value: AdPlatform
}

export const PlatformToggle: FC<PlatformToggleProps> = ({
  onChange,
  value,
}) => (
  <div className={classes.toggle}>
    <button
      className={`${classes.option} ${value === 'meta' ? classes.optionActive : ''}`}
      onClick={() => onChange('meta')}
      type="button"
    >
      <MetaAdsIcon className={classes.icon} />
      Meta Ads
    </button>
    <button
      className={`${classes.option} ${value === 'google' ? classes.optionActive : ''}`}
      onClick={() => onChange('google')}
      type="button"
    >
      <GoogleAdsIcon className={classes.icon} />
      Google Ads
    </button>
  </div>
)
